import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { CreditCheckRequest, CreditCheckResponse, Quote } from "src/api-service";
import { AppError } from "../../../app-store-error.types";

// **************************************************************************
// CREDIT CHECK ACTIONS
// **************************************************************************

export const CreditCheckActions = createActionGroup({
    source: "Data / Credit Check",
    events: {
        // ******** SUBSCRIPTION FLOW ******** //
        // Used during subscription creation to check customer creditworthiness
        "Run Subscription Check": props<{
            request: CreditCheckRequest;
            successToastKey: string;
            errorToastKey: string;
        }>(),
        "Run Subscription Check Success": props<{ response: CreditCheckResponse; toastKey: string }>(),
        "Run Subscription Check Failure": props<{ error: AppError; toastKey: string }>(),
        "Override Subscription Denial": emptyProps(),
        "Reset Subscription": emptyProps(),
        "Update Subscription Customer Code": props<{ customerCode: string }>(),

        // ******** QUOTE FLOW ******** //
        // Used during quote send/order flow to verify credit status
        // Note: The actual credit check result is stored on the Quote object
        "Run Quote Check": props<{ quoteId: number; versionId: number }>(),
        "Run Quote Check Success": props<{ quote: Quote }>(),
        "Run Quote Check Failure": props<{ error: AppError; toastKey: string }>(),
        "Override Quote Check": props<{ quoteId: number }>(),
        "Override Quote Check Success": props<{ quote: Quote; toastKey: string }>(),
        "Override Quote Check Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
